module.exports = __webpack_public_path__ + "static/media/siddharth-nandi-hills-trip-10.9fc99214.png";